import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳 ViewData
 */
const IdDocUploadViewData = [
    'POST',
    RouteUrlList.API_IdDocUploadViewData.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: '',

        imageMaxSize: 8,
        idFront: '',
        idBack: '',
        secondIdFront: '',
        handHeldIDCard: '',
        ssn: 'A123456789',
        // 10001 ,北縣, 3
        idCheck_P_Collection: [{ enum_id: '1', enum_nm: '北縣', enum_desc: '3' }],
        idCheck_P: '',
        idCheck_T: '',
        idCheck_Y: '',
        idCheck_M: '',
        idCheck_D: ''
    }
];
export default IdDocUploadViewData;
